import React from "react";

// Exact dropdown caret from the MAX design system (Figma node 3098:811): a 16×8 chevron
// centered in a 24px box, 1.333px stroke, round caps. stroke=currentColor so the
// consumer's color (orange when active, grey when disabled — see theme MuiAutocomplete /
// MuiOutlinedInput) drives it. Used as the Autocomplete `popupIcon`.
export const DropdownChevron: React.FC<{ className?: string }> = ({ className }) => (
	<svg
		className={className}
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M4 8L12 16L20 8"
			stroke="currentColor"
			strokeWidth={1.33333}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
